import { useEffect, useState } from "react";
import { IoIosArchive } from "react-icons/io";
import { categories, rawMaterials } from "../../utlis/apiService";
import { notify } from "../../common/Toast";

const AllStocks = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isCategoryData, setIsCategoryData] = useState([]);
  const [isRawMaterialStock, setIsRawMaterialStock] = useState([]);

  const fetchRawMaterialStockData = async (categoryId) => {
    setLoading(true);
    try {
      const res = await rawMaterials.getRawMaterialStock(categoryId);
      setIsRawMaterialStock(res || []);
    } catch (error) {
      notify("Error fetching die status data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchCategoryData = async () => {
    setLoading(true);
    try {
      const res = await categories.getAll();
      setIsCategoryData(res || []);
      if (res && res.length > 0) {
        const defaultId = res[0].id;
        setSelectedCategoryId(defaultId);
        fetchRawMaterialStockData(defaultId);
      }
    } catch (error) {
      notify("Error fetching categories", "error");
    }
    setLoading(false);
  };

  const handleCategoryChange = (e) => {
    const id = parseInt(e.target.value);
    setSelectedCategoryId(id);
    fetchRawMaterialStockData(id);
  };
  const selectedCategory = isCategoryData.find(
    (cat) => cat.id === selectedCategoryId
  );
  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5 mt-10 ">
        <div className="flex items-center space-x-2 mb-6">
          <IoIosArchive className="w-8 h-8 text-primary" />
          <h2 className="text-2xl font-semibold text-slate-800">
            All Stocks Overview
          </h2>
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select Stock Category
          </label>
          <select
            value={selectedCategoryId}
            onChange={handleCategoryChange}
            className="w-full md:w-1/3 px-4 py-2 border-2 border-primary rounded-md focus:outline-none focus:ring-1 focus:ring-primary text-sm"
          >
            {isCategoryData.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>
        <div className="border shadow-md border border-gray rounded p-4">
          <p className="text-secondary text-lg font-semibold mb-4">
            {selectedCategory?.name}
          </p>
          <div className="overflow-x-auto">
            {loading ? (
              <p className="text-center text-gray-500 py-4">Loading...</p>
            ) : (
              <table className="min-w-full text-sm text-left ">
                <thead className="bg-slate-100 font-semibold text-gray-700">
                  <tr>
                    {selectedCategoryId === 1 && (
                      <th className="px-4 py-2">SKU</th>
                    )}
                    <th className="px-4 py-2">TYPE</th>
                    <th className="px-4 py-2">GRADE</th>
                    <th className="px-4 py-2">SUPPLIER</th>
                    <th className="px-4 py-2">AVAILABLE QTY</th>
                    <th className="px-4 py-2">UNIT</th>
                  </tr>
                </thead>
                <tbody>
                  {isRawMaterialStock.map((item, i) => (
                    <tr key={i} className="border-t">
                      {selectedCategoryId === 1 && (
                        <td className="px-4 py-2">{item.skU_NO}</td>
                      )}
                      <td className="px-4 py-2">{item.materiaL_NAME}</td>
                      <td className="px-4 py-2">{item.grade || "-"}</td>
                      <td className="px-4 py-2">{item.supplier_Name}</td>
                      <td className="px-4 py-2">{item.quantity}</td>
                      <td className="px-4 py-2">{item.unit_Name}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-slate-50 font-semibold text-sm text-gray-800">
                    <td
                      colSpan={selectedCategoryId === 1 ? 5 : 4}
                      className="px-4 py-2 text-right"
                    >
                      Total Available:
                    </td>
                    <td className="px-4 py-2">
                      {isRawMaterialStock
                        .reduce(
                          (sum, item) => sum + parseFloat(item.quantity || 0),
                          0
                        )
                        .toFixed(2)}{" "}
                      kg
                    </td>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        </div>{" "}
      </div>
    </>
  );
};

export default AllStocks;
